import classnames from 'classnames';
import React from 'react';
import { getIcon } from '../../components/Icons';
import { DOWNLOADABLES } from '../../utils/constants';
import './DownloadableResources.scss';
import ResourcesSelect from './ResourcesSelect';
import { DownloadableResourceProps, DownloadableResourcesProps } from '../../entities/Resource';

export default function DownloadableResources({ downloads }: DownloadableResourcesProps): React.ReactElement {
  //Build list of downloadables from the actual files available
  if (downloads.edges.length === 0) return null;
  const downloadables = DOWNLOADABLES.map((value) => {
    //Found si
    const file = downloads.edges.find((element) => element.node.base.endsWith(value.file));

    const multipleSchematics = downloads.edges.filter((element) => element.node.base.endsWith(value.file) && value.file === 'schematics.pdf');
    if (value.file === 'schematics.pdf' && multipleSchematics.length > 1) {
      return {
        name: value.name,
        file: file.node.publicURL,
        link: null,
        icon: value.icon,
        multipleSchematics: multipleSchematics,
      };
    }

    let link = '';
    if (!file) {
      return null;
    }

    if (value.name === 'Pinout (PDF)') {
      link = 'https://docs.arduino.cc/resources/pinouts/' + file.node.base;
    } else if (value.name === 'Datasheet') {
      link = 'https://docs.arduino.cc/resources/datasheets/' + file.node.base;
    } else if (value.name === 'Schematics') {
      link = 'https://docs.arduino.cc/resources/schematics/' + file.node.base;
    } else {
      link = file.node.publicURL;
    }
    return {
      name: value.name,
      file: file.node.publicURL,
      link: link,
      icon: value.icon,
    };

    // 'https://docs.arduino.cc/resources/datasheets/' + base
  }).filter((element) => element !== null); // Cleanup list from non-existent links

  return (
    <div className="resources">
      <div className="resources__title">
        <h2>Downloadable resources</h2>
      </div>
      {downloadables.length > 0 && (
        <div className={classnames('resources__items', { 'resources__items--left': downloadables.length < 4 })}>
          {downloadables.map((resource: DownloadableResourceProps) => {
            if (resource.name === 'Schematics' && resource.multipleSchematics) {
              return <ResourcesSelect key={resource.name + ' ' + resource.file} resource={resource} />;
            } else {
              return (
                <a key={resource.name + ' ' + resource.file} href={resource.link} target="_blank" rel="noreferrer">
                  <span className="resources__icon">{getIcon(resource.icon)}</span>
                  <div className="resources__text">{resource.name}</div>
                </a>
              );
            }
          })}
        </div>
      )}
    </div>
  );
}
